import Helper from './Helper';

class SearchForm {
  constructor(config = {}) {
    const {
      searchFormInput
    } = config;

    this.searchFormInput = document.querySelector(searchFormInput);
    this.searchFocus = false;

    this.bindEvents();
  }

  bindEvents() {
    if ( !! this.searchFormInput ) {
      this.searchFormInput.addEventListener("focusin", (e) => {
        this.searchInputFocusIn();
      });
    }

    if ( !! this.searchFormInput ) {
      this.searchFormInput.addEventListener("focusout", (e) => {
        this.searchInputFocusOut();
      });
    }
  }

  searchInputFocusIn() {
    if (this.searchFocus) {
      Helper.removeClass(this.searchFormInput.parentNode, 'has-focus')
      this.searchFocus = false;
    } else {
      Helper.addClass(this.searchFormInput.parentNode, 'has-focus')
      this.searchFocus = true;
    }
  }

  searchInputFocusOut() {
    if (this.searchFocus) {
      Helper.removeClass(this.searchFormInput.parentNode, 'has-focus')
      this.searchFocus = false;
    }
  }
}

export default SearchForm;
